/**
 * AIDEN Streetwear -- Custom Animations
 */

const initCustomAnimations = () => {
  initCardReveal();
  initHeroParallax();
};

function initCardReveal() {
  const cards = document.querySelectorAll('.card-wrapper');
  if (!cards.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        const siblings = Array.from(entry.target.parentElement?.children || []);
        const idx = siblings.indexOf(entry.target);
        const delay = idx * 80;

        setTimeout(() => {
          entry.target.classList.add('is-visible');
        }, delay);

        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    threshold: 0.05,
    rootMargin: '0px 0px -40px 0px'
  });

  cards.forEach(card => observer.observe(card));
}

function initHeroParallax() {
  const bgWrapper = document.querySelector('[data-parallax]');
  if (!bgWrapper) return;

  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const scrollY = window.scrollY;
        const rate = scrollY * 0.3;
        bgWrapper.style.setProperty('--parallax-y', `${rate}px`);
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomAnimations);
} else {
  initCustomAnimations();
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    initCustomAnimations();
  });
}
